import { createContext, type ReactNode, useContext, useRef, useSyncExternalStore } from 'react';
import { type AiBuilderActiveOperation, type AiBuilderSessionStore, createAiBuilderSessionStore } from '../stores/aiBuilderSessionStore';
const AiBuilderSessionStoreContext = createContext<AiBuilderSessionStore | null>(null);

/** 빌드 화면의 AI 채팅과 생성기가 같은 서버 세션과 작업 상태를 공유하게 한다. */
export const AiBuilderSessionProvider = ({
  children
}: {
  children?: ReactNode;
}) => {
  const storeRef = useRef<AiBuilderSessionStore | null>(null);
  if (!storeRef.current) {
    storeRef.current = createAiBuilderSessionStore();
  }
  return <AiBuilderSessionStoreContext.Provider value={storeRef.current} data-sentry-element="unknown" data-sentry-component="AiBuilderSessionProvider" data-sentry-source-file="AiBuilderSessionProvider.tsx">
      {children}
    </AiBuilderSessionStoreContext.Provider>;
};

/** Provider 밖(단독 렌더 테스트·스토리)에서는 null — 공유 없이 동작한다. */
export const useOptionalAiBuilderSessionStore = () => useContext(AiBuilderSessionStoreContext);
const subscribeNoop = () => () => undefined;
const getNoOperation = () => null;
export const useAiBuilderActiveOperation = (): AiBuilderActiveOperation | null => {
  const store = useContext(AiBuilderSessionStoreContext);
  return useSyncExternalStore(store?.subscribe ?? subscribeNoop, store?.getActiveOperation ?? getNoOperation, store?.getActiveOperation ?? getNoOperation);
};